import React, { useEffect, useState } from "react";
import CustomSkeleton from "../../../control-components/skeleton/skeleton";
import { ListView, ListViewHeader } from "@progress/kendo-react-listview";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { clinicService } from "../../../services/clinicService";
import { NotificationManager } from "src/util/notify";
import { Loader } from "@progress/kendo-react-indicators";
import moment from "moment";


const Days = [
  { name: "Current Month", value: "currentMonth" },
  { name: "Last 3 Months", value: "last3Months" },
  { name: "Last 6 Months", value: "last6Months" },
  { name: "Last 9 Months", value: "last9Months" },
  { name: "Last 1 Year", value: "last1Year" },
  { name: "YTD", value: "ytd" },
];

const ClinicBillingInfo = ({ clinicInfo }) => {
  const [isShowItems, setShowItems] = useState(false);
  const [day, setDay] = useState({ name: "Last 3 Months", value: "last3Months" });
  const [clinicBillingInfo, setClinicBillingInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalClaims, setTotalClaims] = useState(0);
  const [totalBilling, setTotalBilling] = useState(0);

  useEffect(() => {
    if (clinicInfo !== null || clinicInfo !== undefined) {
      getClinicBillingInfo();
    }
  }, [day]);

  useEffect(() => {
    let totClaim = clinicBillingInfo.reduce(
      (acc, item) => acc + item.totClaimsByMonth,
      0
    );
    setTotalClaims(totClaim);

    let totBilling = clinicBillingInfo.reduce(
      (acc, item) => acc + item.totBilledByMonth,
      0
    );
    setTotalBilling(totBilling);
  }, [clinicBillingInfo]);


  const getClinicBillingInfo = async () => {
    setLoading(true);

    const endDate = new Date();
    let startDate = new Date();

    switch (day.value) {
      case "currentMonth":
        startDate.setDate(1);
        break;
      case "last3Months":
        startDate.setMonth(endDate.getMonth() - 2);
        startDate.setDate(1);
        break;
      case "last6Months":
        startDate.setMonth(endDate.getMonth() - 5);
        startDate.setDate(1);
        break;
      case "last9Months":
        startDate.setMonth(endDate.getMonth() - 8);
        startDate.setDate(1);
        break;
      case "last1Year":
        startDate.setFullYear(endDate.getFullYear() - 1);
        startDate.setMonth(endDate.getMonth());
        startDate.setDate(1);
        break;

      case "ytd":
        startDate.setFullYear(endDate.getFullYear());
        startDate.setMonth(0);  // Set to January (month index 0)
        startDate.setDate(1);
        break;

      default:
        startDate.setDate(1);
    }

    const dateObject = {
      clinicId: clinicInfo.field.masterClinicId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      regionId: clinicInfo.field.regionId,
    };

    await clinicService
      .getClinicBillingInfo(dateObject)
      .then((result) => {
        setLoading(false);
        const data = result.resultData;
        setClinicBillingInfo(data);
        setShowItems(true);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const handleChange = (e) => {
    setDay(e.value);
  };

  const MyHeader = () => {
    return (
      <ListViewHeader className="listview-header">
        <div className="row border-bottom align-middle m-0 py-2">
          <div className="col">
            <h6 className="f-14">Month</h6>
          </div>
          <div className="col">
            <h6 className="f-14">Claims</h6>
          </div>
          <div className="col">
            <h6 className="f-14">Total Billed</h6>
          </div>
        </div>
      </ListViewHeader>
    );
  };

  const MyItemRender = (props) => {
    let item = props.dataItem;
    return (
      <>
        {clinicBillingInfo?.length > 0 ? (
          <div className="row py-2 border-bottom align-middle listview-row m-0">
            <div className="col">
              {!isShowItems ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>
                  {item.monthName} {item.yr}
                </div>
              )}
            </div>
            <div className="col">
              {!isShowItems ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>{item.totClaimsByMonth}</div>
              )}
            </div>
            <div className="col">
              {!isShowItems ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(item.totBilledByMonth)}
                </div>
              )}
            </div>
          </div>
        ) : (
          "No Data Found"
        )}
      </>
    );
  };

  return (
    <>
      {loading === true ? <Loader />
        : <div className="clinic-template-container bg-white p-3">
          <div className="clinic-template-header pb-2">
            <div className="clinic-template-header-content">
              <h5 className="clinic-template-title">Billing by Month</h5>
              <div className="clinic-template-dropdown">
                <DropDownList
                  onChange={handleChange}
                  data={Days}
                  value={day}
                  textField="name"
                  dataItemKey="value"
                  defaultValue={Days[0].value}
                />
              </div>
            </div>
          </div>
          {clinicBillingInfo.length > 0 ? (
            <ListView
              data={clinicBillingInfo}
              item={MyItemRender}
              className="listview-container"
              header={MyHeader}
            />
          ) : (
            <div className="no-data-container">No data found</div>
          )}
        </div>
      }

      <div className="total-template-container">
        {loading === false ? (
          <>
            <div className="total-template-info">
              <i className="fa fa-file-invoice total-template-icon"></i>
              <span>Total Claims: {totalClaims}</span>
            </div>
            <div className="total-template-info">
              <i className="fa fa-credit-card total-template-icon"></i>
              Total Billing:{" "}
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(totalBilling)}
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </>
  );
};

export default ClinicBillingInfo;

